import { Options } from '../options.interface';
import { JOB_API_CONFIG } from './job-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { buildUrl } from '@wizbii-utils/angular/core';
import { Contract } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

@Injectable()
export class ContractWebservice {
  readonly http = inject(HttpClient);
  readonly jobApiConfig = inject(JOB_API_CONFIG);

  readonly baseUrl = this.jobApiConfig.baseUrl;

  /**
   * Get the contracts for a Job according to the locale
   * @param {string} [locale=fr_FR] Locale for the contracts
   * @param {Object} [options] Angular Options for the request
   */
  get(locale?: string, options?: Options): Observable<Contract[]> {
    return this.http.get<Contract[]>(buildUrl(`${this.baseUrl}/api/contracts`, { locale }), options);
  }
}
